export default __webpack_public_path__ + "e4b0d6c33c9e865bfcc2f9cf86d30ec4.png";